export const canAutoplay = () => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion)').matches;
  const autoplayEnabled = window.drupalSettings?.featureFlags.carousel_autoplay ?? false;

  return autoplayEnabled && !prefersReducedMotion;
};
